import { render, staticRenderFns } from "./Mspss.vue?vue&type=template&id=7b8db827&scoped=true&lang=pug&"
import script from "./Mspss.vue?vue&type=script&lang=ts&"
export * from "./Mspss.vue?vue&type=script&lang=ts&"
import style0 from "./Mspss.vue?vue&type=style&index=0&id=7b8db827&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8db827",
  null
  
)

export default component.exports